<script setup>
import { onMounted, onUnmounted } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";

let map = null;

onMounted(() => {
  AMapLoader.load({
    key: "d9b0f68a283909496632617dd66385ec", // 申请好的Web端开发者Key，首次调用 load 时必填
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: ["AMap.Scale", "AMap.PlaceSearch"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
  })
    .then((AMap) => {
      var position = new AMap.LngLat(115.90711337, 32.809775);
      map = new AMap.Map("mapksb", {
        // 设置地图容器id
        resizeEnable: true,
        viewMode: "2D", // 是否为3D地图模式
        zoom: 15, // 初始化地图级别
        //position: [113.808299, 34.791787],
        center: position, // 初始化地图中心点位置
      });
      var icon = new AMap.Icon({
        image:
          "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png", // Icon的图像
        //size: new AMap.Size(36, 36), // 图标尺寸
        //imageSize: new AMap.Size(36, 36), // 根据所设置的大小拉伸或压缩图片
      });
      var marker = new AMap.Marker({
        position: map.getCenter(),
        icon: icon,
        //anchor: "bottom-center",
        offset: new AMap.Pixel(-18, -36),
      });
      marker.setMap(map);

      // 设置鼠标划过点标记显示的文字提示
      marker.setTitle("考试宝典阜阳安医店");

      // 设置label标签
      // label默认蓝框白底左上角显示，样式className为：amap-marker-label
      marker.setLabel({
        direction: "right",
        offset: new AMap.Pixel(10, 0), //设置文本标注偏移量
        content:
          "<div class='info'><p>考试宝典线下体验中心店</p><p>(刘老师:18019941066)</p></div>", //设置文本标注内容
      });
    })

    .catch((e) => {
      console.log(e);
    });
});

onUnmounted(() => {
  map?.destroy();
});
</script>

<template>
  <div id="mapksb"></div>
</template>

<style lang="less">
html,
body,
#mapksb {
  height: 100%;
  width: 100%;
}

.amap-icon img {
  width: 25px;
  height: 34px;
}

.amap-marker-label {
  border: 0;
  background-color: transparent;
}

.info {
  position: relative;
  margin: 0;
  top: -44px;
  right: 41px;
  min-width: 0;
  font-size: 18px;
  color: #777;
  p {
    padding-top: 5px;
  }
}
</style>
